import { render, staticRenderFns } from "./MCQEditor.vue?vue&type=template&id=7b54799b&scoped=true&"
import script from "./MCQEditor.vue?vue&type=script&lang=js&"
export * from "./MCQEditor.vue?vue&type=script&lang=js&"
import style0 from "./MCQEditor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MCQEditor.vue?vue&type=style&index=1&id=7b54799b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b54799b",
  null
  
)

export default component.exports